import React from 'react'
import { ButtonLink } from './index.styled'

const Button = ({ children, ...props }) => {
  return <ButtonLink {...props}>{children}</ButtonLink>
}

export default Button
